import React, { useState } from "react";
import { MdPeople, MdGroups, MdOutlineHouseboat } from "react-icons/md";
import { HiShoppingBag } from "react-icons/hi";
import Image01 from "../assets/feedLocation.svg";

const GroupLeft = ({ setCommunity, community, setGroup }) => {
  const [Location] = useState(window.location.pathname.split(" ")[0]);
  return (
    <div
      className={
        "w-[20%] pb-10 sticky top-[110px] h-[calc(100vh-110px)] overflow-scroll scrollbar-hide"
      }
    >
      <div className={`relative ${Location.includes("/weather") && "!hidden"}`}>
        <div
          className={`flex items-center justify-start border-2 rounded-xl py-3 px-5 text-primary text-sm font-medium mb-3 cursor-pointer hover:border-none hover:bg-primary hover:text-white ${
            community === "connections" && "bg-primary text-[#fff] border-none"
          }`}
          onClick={() => {
            if (community !== "connections") setCommunity("connections") 
            else  setCommunity("")
          }}
        >
          <MdPeople className="text-2xl" />
          <p className="pl-5">Connections</p>
        </div>
        <div
          className={`flex items-center justify-start border-2 rounded-xl py-3 px-5 text-primary text-sm font-medium mb-3 cursor-pointer hover:border-none hover:bg-primary hover:text-white ${
            community === "neighbors" && "bg-primary text-[#fff] border-none"
          }`}
          onClick={() => {
            if (community !== "neighbors") setCommunity("neighbors") 
            else  setCommunity("")
          }}
        >
          <MdOutlineHouseboat className="text-2xl" />
          <p className="pl-5">Neighbors</p>
        </div>
        <div
          className={`flex items-center justify-start border-2 rounded-xl py-3 px-5 text-primary text-sm font-medium mb-3 cursor-pointer hover:border-none hover:bg-primary hover:text-white ${
            community === "groups" && "bg-primary text-[#fff] border-none"
          }`}
          onClick={() => {
            if (community !== "groups") {
              setCommunity("groups");
              setGroup("");
            }
            else setCommunity("")
          }}
        >
          <MdGroups className="text-2xl" />
          <p className="pl-5">Groups</p>
        </div>
        <div
          className={`flex items-center justify-start border-2 rounded-xl py-3 px-5 text-primary text-sm font-medium mb-3 cursor-pointer hover:border-none hover:bg-primary hover:text-white ${
            community === "businesses" && "bg-primary text-[#fff] border-none"
          }`}
          onClick={() => {
            if (community !== "businesses") {
              setCommunity("businesses")
            }else setCommunity("")
          }}
        >
          <HiShoppingBag className="text-2xl" />
          <p className="pl-5">Businesses</p>
        </div>
      </div>
      <div className="border-2 rounded-xl p-5 mb-3">
        <p className="text-sm font-bold">Current Location</p>
        <p className="text-xs font-semibold text-primary pb-4">Brooklyn</p>
        <div className="flex justify-center items-center pb-5">
          <img src={Image01} alt="" />
        </div>
        <div className="flex justify-between items-center font-medium text-primary text-sm">
          <p>Clear</p>
          <p>6OC</p>
        </div>
      </div>
      <div className="border-2 rounded-xl p-5 mb-3">
        <p className="text-sm font-bold">Your Community Circle</p>
        <p className="text-[30px] font-medium text-primary text-center py-1">
          30%
        </p>
        <p className="text-xs font-medium text-center">
          Members Risk Ready
          <br /> out off
        </p>
        <p className="text-[30px] font-medium text-primary text-center py-1">
          32000
        </p>
        <p className="text-xs font-medium text-center">Members</p>
      </div>
    </div>
  );
};

export default GroupLeft;
